import { Controller } from '@hotwired/stimulus'
import { Dropdown } from 'flowbite'

export default class extends Controller {
  static targets = ['menu', 'trigger']
  static values = { options: String }

  hide() {
    this.dropdown.hide()
  }

  connect() {
    this.dropdown = new Dropdown(
      this.menuTarget,
      this.triggerTarget,
      JSON.parse(this.optionsValue)
    )
  }
}
